"use strict";
/**
* AllowBackgroundFetchData.ts
* Author: CALIB http://aka.ms/CALIB
* Copyright: Microsoft 2017
*
* Holder for information if background fetch is allowed
*/
Object.defineProperty(exports, "__esModule", { value: true });
var SyncTasks = require("synctasks");
var AllowBackgroundFetchData = /** @class */ (function () {
    function AllowBackgroundFetchData() {
        this._isAllowed = false;
    }
    AllowBackgroundFetchData.prototype.putBackgroundFetchAllowed = function (isAllowed) {
        this._isAllowed = isAllowed;
        if (this.isBackgroundFetchAllowed() && this._isAllowedDeferral) {
            var deferral = this._isAllowedDeferral;
            this._isAllowedDeferral = undefined;
            deferral.resolve(void 0);
        }
    };
    AllowBackgroundFetchData.prototype.isBackgroundFetchAllowed = function () {
        return this._isAllowed;
    };
    AllowBackgroundFetchData.prototype.waitForBackgroundFetchAllowed = function () {
        if (this.isBackgroundFetchAllowed()) {
            return SyncTasks.Resolved();
        }
        // Set up deferral to wait until background fetch is allowed
        if (!this._isAllowedDeferral) {
            this._isAllowedDeferral = SyncTasks.Defer();
        }
        return this._isAllowedDeferral.promise();
    };
    return AllowBackgroundFetchData;
}());
exports.default = AllowBackgroundFetchData;
